export default __webpack_public_path__ + "static/media/uploader-ascensiaContourNextMeter-2.56af2707.png";